/**
 * Orly Einav Ofir - Theme JavaScript
 * Main theme functionality
 */

(function() {
  'use strict';

  // Header scroll behavior
  const header = document.querySelector('.header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 50) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // Announcement bar close
  const announcementClose = document.querySelector('.announcement-bar__close');
  if (announcementClose) {
    announcementClose.addEventListener('click', () => {
      const announcementBar = document.querySelector('.announcement-bar');
      if (announcementBar) {
        announcementBar.style.display = 'none';
        sessionStorage.setItem('announcement-dismissed', 'true');
      }
    });

    // Check if already dismissed
    if (sessionStorage.getItem('announcement-dismissed') === 'true') {
      const announcementBar = document.querySelector('.announcement-bar');
      if (announcementBar) {
        announcementBar.style.display = 'none';
      }
    }
  }

  // Mobile menu toggle
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('mobile-nav--open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.classList.toggle('menu-open', isOpen);
    });
  }

  // Search toggle
  const searchToggle = document.querySelector('.search-toggle');
  const searchModal = document.querySelector('.search-modal');
  if (searchToggle && searchModal) {
    searchToggle.addEventListener('click', () => {
      searchModal.classList.toggle('search-modal--open');
      const searchInput = searchModal.querySelector('input');
      if (searchInput) {
        searchInput.focus();
      }
    });

    // Close on escape
    searchModal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        searchModal.classList.remove('search-modal--open');
      }
    });
  }

  // Product card hover effects
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      card.classList.add('product-card--hovered');
    });
    card.addEventListener('mouseleave', () => {
      card.classList.remove('product-card--hovered');
    });
  });

  // Lazy loading images
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[data-src]');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          imageObserver.unobserve(img);
        }
      });
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

  // Form validation
  const forms = document.querySelectorAll('form[data-validate]');
  forms.forEach(form => {
    form.addEventListener('submit', (e) => {
      const requiredFields = form.querySelectorAll('[required]');
      let isValid = true;

      requiredFields.forEach(field => {
        if (!field.value.trim()) {
          isValid = false;
          field.classList.add('input--error');
        } else {
          field.classList.remove('input--error');
        }
      });

      if (!isValid) {
        e.preventDefault();
      }
    });
  });

  // Newsletter form
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = newsletterForm.querySelector('input[type="email"]');
      const button = newsletterForm.querySelector('button');

      if (email && email.value) {
        button.textContent = 'שולח...';
        button.disabled = true;

        // Simulate newsletter signup
        setTimeout(() => {
          button.textContent = 'נרשמת בהצלחה!';
          email.value = '';
          setTimeout(() => {
            button.textContent = 'הרשמה';
            button.disabled = false;
          }, 3000);
        }, 1000);
      }
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // Add to cart animation
  window.addToCartAnimation = function(button) {
    const cart = document.querySelector('.header__cart');
    if (cart) {
      cart.classList.add('cart--bounce');
      setTimeout(() => cart.classList.remove('cart--bounce'), 500);
    }
    if (button) {
      const originalText = button.textContent;
      button.textContent = 'נוסף!';
      button.classList.add('btn--success');
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('btn--success');
      }, 2000);
    }
  };

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    // Fade in page content
    document.body.classList.add('loaded');
  });

})();
